import LocalApa from './LocalApa';

class LocalAssets extends LocalApa {}

export default LocalAssets;



// WEBPACK FOOTER //
// ./src/requests/apa/local/LocalAssets.js